const STORAGE_KEY = 'loanflow_ref';

/**
 * Capture referral code from URL query parameter (?ref=code)
 * and store in sessionStorage for use during signup.
 */
export function captureReferralCode(): void {
  const params = new URLSearchParams(window.location.search);
  const ref = params.get('ref');
  if (ref) {
    sessionStorage.setItem(STORAGE_KEY, ref.trim().toLowerCase());
  }
}

/**
 * Retrieve stored referral code (if any).
 */
export function getReferralCode(): string | null {
  return sessionStorage.getItem(STORAGE_KEY);
}

/**
 * Clear the stored referral code after successful application.
 */
export function clearReferralCode(): void {
  sessionStorage.removeItem(STORAGE_KEY);
}
